jQuery(document).ready(function ($) {
    $(".footer__location .location_item > .location_title, .contact_popup__location .location_item > .location_title").on("click", function (event) {
        $(this).next().slideToggle().parent().toggleClass('open');
    });

    $(".accordion .accordion-item > .accordion-header").on("click", function (event) {
        $(this).parent().siblings().removeClass('active').children('.accordion-content').slideUp();
        $(this).parent().toggleClass('active').children('.accordion-content').slideToggle();
    });

    $(".item-cards-block-v3__inner .item__inner > .icon").on("click", function (event) {
        $(this).parent().toggleClass('open');
        $(this).prev().find('.moreText').slideToggle();
    });

    jQuery('.copy_to_clipboard').on('click', function () {
        var temp = jQuery("<input>");
        var linkToCopy = jQuery(this).attr("data-link");
        if (linkToCopy != "" && linkToCopy != null && linkToCopy != undefined) {
            jQuery("body").append(temp);
            temp.val(linkToCopy).select();
            document.execCommand("copy");
            temp.remove();
        }
    })

    $('a[href="#contactPopup"]').on("click", function (event) {
        event.preventDefault();
        $('.header > .contact_popup').addClass('open');
        $('body').addClass('loackScroll');
    });

    $(".contact_popup__close").on("click", function (event) {
        event.preventDefault();
        $('.header > .contact_popup').removeClass('open');
        $('body').removeClass('loackScroll');
    });


    // if ($("body:not(.home)").length > 0 && $("#site-content").length > 0) {
    //     var headerPos = jQuery("header#header").outerHeight();
    //     // if ($("#wpadminbar").length > 0) {
    //     //     headerPos = headerPos + $("#wpadminbar").outerHeight();
    //     // }

    //     $("#site-content").css("padding-top", headerPos);
    // }


});